import ScenarioCarousels from "./ScenarioCarousels";

const EducationScenarios = () => {
  return <ScenarioCarousels variant="education" />;
};

export default EducationScenarios;